/**
 * Centralized API & Server Configuration
 * Reads from process.env with fallback defaults for seamless Hostinger production deployment.
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/server/api';
const ADMIN_LOGIN_URL = process.env.REACT_APP_ADMIN_LOGIN_URL || '/server/admin/login.php';
const SERVICE_CENTER_URL = process.env.REACT_APP_SERVICE_CENTER_URL || '/server/api/search_service_centers.php';
const SERVER_URL = process.env.REACT_APP_SERVER_URL || '/server';

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  LOGIN_URL: ADMIN_LOGIN_URL,
  SERVICE_CENTERS_URL: SERVICE_CENTER_URL,
  SERVER_URL: SERVER_URL,

  /**
   * Helper to safely format image URLs (local uploads, server assets, or external photos)
   */
  getImageUrl: (imagePath) => {
    if (!imagePath) return '/Photo/i7 air 2.jpg';
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    if (imagePath.startsWith('/')) {
      return imagePath;
    }
    return `${SERVER_URL}/${imagePath}`;
  }
};

export default API_CONFIG;
